// extracted by mini-css-extract-plugin
export default {"container":"ProfileAvatar_container__PbNPQ","name":"ProfileAvatar_name__U7E5+","role":"ProfileAvatar_role__Wel+h"};